import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Toolbar from '../App/Toolbar';
import Paper from 'material-ui/Paper';
import Divider from 'material-ui/Divider';
import LinearProgress from 'material-ui/LinearProgress';
import ErrorSnackbar from './ErrorSnackbar';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import { CardHeader } from 'material-ui/Card';
import { LandscapeOrientation } from '../Print/LandscapeOrientation';
import SearchToolbar from '../App/SearchToolbar.react';
import { SearchTypes } from '../../constants/CentricConstants';

import SearchStore from '../../stores/SearchStore';

const style = {
    paper:  {
        marginTop: '67px',
        marginRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        borderTop: '1px solid #e0e0e0'
    }
};

const getHeaderColumn = (item, i) => {
    if (!item && (item !== '')) { return null; }
    if (typeof item === 'string') {
        return <TableHeaderColumn key={i}>{item}</TableHeaderColumn>;
    }
    const {label, ...props} = item;
    return <TableHeaderColumn key={i} {...props}>{label}</TableHeaderColumn>;
};

class TableView extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            selected: this.props.selected,
            searchMode: false,
            results: []
        };
    }

    componentDidMount() {
        this.onRowSelection = this.onRowSelection.bind(this);
        this.toggleSearchMode = this.toggleSearchMode.bind(this);
        this.getSearchResults = this.getSearchResults.bind(this);
        this.searchListener = SearchStore.addListener(this.getSearchResults);
    }

    componentWillUnmount() {
        this.searchListener.remove();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.selected !== this.props.selected) {
            this.setState({selected: nextProps.selected});
        }
    }

    render() {
        const selectable = (this.props.selectable || this.props.multiSelectable);
        const enableSelectAll = (this.props.multiSelectable && this.props.enableSelectAll);

        const tableProps = selectable ? {
            onRowSelection: this.onRowSelection,
            allRowsSelected: (this.state.selected === "all")
        } : {};

        const tableRows = (!this.state.searchMode ? this.props.rows : this.state.results).map((row, i) => {
            const rowProps = { selectable };
            if (!!this.props.itemActions) {
                rowProps.actions = this.props.itemActions;
            }

            if (selectable && this.state.selected !== "all" && this.state.selected.length > 0) {
                rowProps.selected = (("all" === this.state.selected) || this.state.selected.includes(i));
            }

            return (<this.props.decorator key={row.key || i} row={row} {...rowProps} />);
        }, this);

        let toolbar;
        if (this.state.searchMode) {
            toolbar = (
                <SearchToolbar
                    searchResult={this.state.results}
                    backTo={this.toggleSearchMode}
                    action={this.props.searchAction}
                />
            );
        } else {
            toolbar = (
                <Toolbar
                    title=""
                    backButton={this.props.backButton}
                    backTo={this.props.backTo}
                    loading={!!this.props.isFetching}
                    filterOptions={this.props.filterOptions}
                    filterAction={this.props.filterAction}
                    sortOptions={this.props.sortOptions}
                    sortAction={this.props.sortAction}
                    actions={(!!this.props.actions && this.props.actions.length > 0) ? this.props.actions : undefined}
                    searchable={!!this.props.searchAction}
                    toggleSearchMode={this.toggleSearchMode}
                />
            );
        }

        return (
            <div>
                {toolbar}
                <Paper className="cent-paper" style={style.paper} >
                    {this.props.title && <CardHeader title={this.props.title} subtitle={this.props.subtitle} />}
                    {(!!this.props.isFetching && <LinearProgress mode="indeterminate" />)}
                    <Table
                        className="cent-table"
                        selectable={selectable}
                        multiSelectable={this.props.multiSelectable}
                        fixedHeader={this.props.fixedHeader}
                        {...tableProps}
                    >
                        <TableHeader
                            enableSelectAll={enableSelectAll}
                            displaySelectAll={enableSelectAll}
                            adjustForCheckbox={selectable}
                        >
                            <TableRow>
                                {this.props.headers.map(getHeaderColumn)}
                            </TableRow>
                        </TableHeader>
                        <TableBody
                            selectable={selectable}
                            multiSelectable={this.props.multiSelectable}
                            displayRowCheckbox={selectable}
                            deselectOnClickaway={false}
                        >
                            {tableRows}
                        </TableBody>
                    </Table>
                    {(!!this.props.tableActions && this.props.tableActions.length > 0) && (
                        <div>
                            <Divider />
                            {this.props.tableActions}
                        </div>
                    )}
                </Paper>
                {this.props.children}
                <ErrorSnackbar />
                <LandscapeOrientation />
            </div>
        );
    }

    onRowSelection(selected) {
        this.setState({selected});
        if (!!this.props.onRowSelection) {
            this.props.onRowSelection(selected);
        }
    }

    toggleSearchMode() {
        const searchMode = !this.state.searchMode;
        this.setState({searchMode});

        if (!!this.props.toggleSearchMode) {
            this.props.toggleSearchMode(searchMode);
        }
    }

    getSearchResults() {
        if (!this.state.searchMode) { return; } //guard

        const { isFetching, results } = SearchStore.getByKey(this.props.searchType) || {};
        if (!isFetching && !!results) {
            this.setState({ results });
        }
    }
}

TableView.propTypes = {
    title:           PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    subtitle:           PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    headers:            PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.string,
            PropTypes.shape({
                label:      PropTypes.string.isRequired
            })
        ])
    ),
    fixedHeader:        PropTypes.bool,
    rows:               PropTypes.array.isRequired,
    decorator:          PropTypes.func,
    actions:            PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ]),
    isFetching:         PropTypes.bool,

    backButton:         PropTypes.bool,
    backTo:             PropTypes.string,

    selectable:         PropTypes.bool,
    multiSelectable:    PropTypes.bool,
    enableSelectAll:    PropTypes.bool,
    selected:           PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.number)
    ]),
    onRowSelection:     PropTypes.func,
    tableActions:       PropTypes.array,
    itemActions:    PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ]),
    filterOptions:    PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ]),
    filterAction:   PropTypes.func,
    sortOptions:    PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ]),
    sortAction:       PropTypes.func,
    searchAction:     PropTypes.func,
    toggleSearchMode: PropTypes.func,
    searchType:       PropTypes.string
};

TableView.defaultProps = {
    headers:            [],
    fixedHeader:        false,
    isFetching:         false,
    backButton:         false,
    backTo:             null,
    selectable:         false,
    multiSelectable:    false,
    enableSelectAll:    false,
    selected:           [],
    actions:            [],
    tableActions:       null,
    itemActions:        null,
    searchType:         SearchTypes.DEFAULT
};

export default TableView;
